import { useState } from "react"
import { Helmet } from "react-helmet-async"
import { IntegrationItem } from "./../../../../../Integrations"
import { useLocation, useParams } from "../../../../../router-utils"
import { Outlet } from "react-router"

export default function MailIntegrationItemDetailsPage() {
	const location = useLocation()
	const { integrationId } = useParams("/integrations/:integrationId/mail")
	const [lastCreatedToken, setLastCreatedToken] = useState<string | undefined>(
		typeof location.state === "string" ? location.state : undefined
	)

	return (
		<>
			<Helmet>
				<title>Mailbox Integration Details</title>
			</Helmet>
			<IntegrationItem
				lastCreatedToken={lastCreatedToken}
				integrationId={integrationId}
				setLastCreatedToken={setLastCreatedToken}
			>
				{({ integration }) => <Outlet context={{ integration }} />}
			</IntegrationItem>
		</>
	)
}
